export interface Type {
  id?: number;
  workflowId?: number;
  workflow?: any;
  name?: string;
  nameTemplate?: string;
  state?: string;
  order?: number;
  class?: string;
  icon?: string;
  color?: string;
  content?: string;
  objectFields?: any;
  environmentId?: number;
}
